import firebase from 'firebase/app';
const db = () => firebase.database().ref('users');

export const UserService = {
  list: () => {
    return db()
      .orderByChild('createDt')
      .once('value')
      .then(snapshot => {
        return Object.values(snapshot.val() || {});
      });
  },
  get: uid => {
    return db()
      .child(uid)
      .once('value')
      .then(snapshot => {
        return snapshot.val();
      });
  },
  update: userInfo => {
    if (!userInfo.uid) return;
    return db()
      .child(userInfo.uid)
      .update(userInfo);
  },
  removeGrade: uid => {
    return Promise.all([
      db()
        .child(uid)
        .child('grade')
        .set('GRD_NORMAL'),
      db()
        .child(uid)
        .child('gradePeriod')
        .remove()
    ]);
  }
};
